export enum TwoFactorAuthenticationMethod {
  App = 1,
  Email = 2,
}
